export const heroData = {
  home: {
    title: ['Remodeling Contractor', 'in Los Angeles, CA'],
    subtitle: "Luxury home remodeling in kitchens, bathrooms, ADUs, and full homes across Southern California.",
    button: "Get a Free Estimate - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  about: {
    title: ['Built on Trust', 'Driven by Excellence'],
    subtitle: "Discover the story and people behind Modern Build",
    button: "Get a Free Estimate - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  financing: {
    title: ['Flexible Financing', 'Options Available'],
    subtitle: "Turn your dream remodel into reality — on your budget",
    button: "Get Financing Info - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  contact: {
    title: ['Let’s Build', 'Something Beautiful'],
    subtitle: "Reach out today for a free consultation or estimate",
    button: "Contact Us Now - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  privacyPolicy: {
    title: ['Your Privacy', 'Matters to Us'],
    subtitle: "Committed to Transparency and Security",
    button: "Get a Free Estimate - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  TermsOfService: {
    title: ['Understand Our', 'Terms of Service'],
    subtitle: "Know Your Rights and Responsibilities When Working With Modern Build",
    button: "Get a Free Estimate - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  PrivacySecurity: {
    title: ['Your Data,', 'Handled With Care'],
    subtitle: "How We Protect Your Privacy and Information Safe",
    button: "Get a Free Estimate - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  servicesAreas: {
    title: ['California Remodeling', 'Coverage Map'],
    subtitle: "Browse remodeling service categories and see which areas we serve by city and ZIP code.",
    button: "Get a Free Estimate - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  sitemap: {
    title: ['Explore Our', 'Full Sitemap'],
    subtitle: "All Pages, Services, Projects, Blogs, and Local Landing Pages",
    button: "Get a Free Estimate - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  services: {
    title: ['Expert Remodeling', 'Services'],
    subtitle: "Explore our full range of renovation and construction specialties",
    button: "Explore All Services - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  kitchen: {
    title: ['Dream Kitchens', 'Made Real'],
    subtitle: "A Stunning & Functional Kitchen Awaits You",
    button: "Get a Free Kitchen Estimate",
    backgroundImage: "/hero/best-kitchen-remodeling-in-los-angeles.webp",
  },
  bathroom: {
    title: ['Luxury Bathroom', 'Transformations'],
    subtitle: "Upgrade Your Bathroom with Style & Comfort",
    button: "Request a Bathroom Quote",
    backgroundImage: "/hero/best-bathroom-remodeling-in-los-angeles.webp",
  },
  completeHome: {
    title: ['Complete Home', 'Remodeling Experts'],
    subtitle: "Transform Your Entire Home with Modern Build",
    button: "Request a Home Remodeling Quote",
    backgroundImage: "/hero/home-remodeling-services-in-los-angeles.webp",
  },
  adu: {
    title: ['ADU & Garage', 'Conversions'],
    subtitle: "Maximize Your Space with a Functional ADU or Garage Makeover",
    button: "Schedule a Free ADU Consultation",
    backgroundImage: "/hero/best-adu-garage-conversion-remodeling-in-los-angeles.webp",
  },
  earthquakeRetrofit: {
    title: ['Earthquake Retrofit', 'Protection'],
    subtitle: "Strengthen Your Home Against Earthquakes with Expert Solutions",
    button: "Get a Retrofit Estimate",
    backgroundImage: "/hero/best-earthquake-retrofit-services-in-los-angeles.webp",
  },
  foundations: {
    title: ['Strong Foundations', 'for a Safe Home'],
    subtitle: "Expert Foundation Repair and Installation Services",
    button: "Book Foundation Inspection",
    backgroundImage: "/hero/best-foundations-remodeling-services-in-los-angeles.webp",
  },
  exteriorPainting: {
    title: ['Exterior Painting', 'for a Stunning Home'],
    subtitle: "Boost Curb Appeal with Professional House Painting",
    button: "Get a Free Painting Quote",
    backgroundImage: "/hero/best-exterior-painting-services-in-los-angeles.webp",
  },
  solarPanels: {
    title: ['Solar Panels', 'for a Greener Future'],
    subtitle: "Save on Energy Bills with Our Solar Solutions",
    button: "Request a Solar Consultation",
    backgroundImage: "/hero/best-solar-panel-services-in-los-angeles.webp",
  },
  energyEfficientWindows: {
    title: ['Energy-Efficient', 'Windows'],
    subtitle: "Upgrade Your Windows for Comfort & Savings",
    button: "Get a Window Estimate",
    backgroundImage: "/hero/best-energy-efficient-windows-services-in-los-angeles.webp",
  },
  pavers: {
    title: ['Beautiful & Durable', 'Pavers'],
    subtitle: "Enhance Your Outdoor Spaces with Custom Pavers",
    button: "Book a Free Paver Consultation",
    backgroundImage: "/hero/best-pavers-hardcaping-services-in-los-angeles.webp",
  },
  outdoorLiving: {
    title: ['Outdoor Living', 'Spaces'],
    subtitle: "Create the Perfect Backyard Retreat with Our Expertise",
    button: "Start Your Outdoor Project",
    backgroundImage: "/hero/best-outdoor-living-hardscaping-services-in-los-angeles.webp",
  },
  artificialTurf: {
    title: ['Artificial Turf', 'for a Perfect Lawn'],
    subtitle: "Enjoy a Low-Maintenance, Green Lawn All Year",
    button: "Get a Turf Installation Quote",
    backgroundImage: "/hero/best-artificial-turf-landscaping-services-in-los-angeles.webp",
  },
  hvac: {
    title: ['HVAC Services', 'for Comfort'],
    subtitle: "Stay Cool in Summer & Warm in Winter with Our Solutions",
    button: "Book an HVAC Consultation",
    backgroundImage: "/hero/best-hvac-services-in-los-angeles.webp",
  },
  asphaltRoof: {
    title: ['Asphalt Shingles Roofing', 'Solutions'],
    subtitle: "Reliable & Affordable Asphalt Shingles Roofing Installation",
    button: "Get a Roof Inspection",
    backgroundImage: "/hero/best-asphalt-shingles-roof-services-in-los-angeles.webp",
  },
  tileRoof: {
    title: ['Tile Roofing', 'Built to Last'],
    subtitle: "Timeless & Durable Roofing for Your Home",
    button: "Discover Tile Roofing Benefits",
    backgroundImage: "/hero/best-tile-roof-services-in-los-angeles.webp",
  },
  flatRoof: {
    title: ['Flat Roof', 'Solutions'],
    subtitle: "Durable & Energy-Efficient Flat Roofing for Any Property",
    button: "Check Our Flat Roofing Services",
    backgroundImage: "/hero/best-flat-roof-services-in-los-angeles.webp",
  },
  metalRoof: {
    title: ['Metal Roofing', 'for Ultimate Durability'],
    subtitle: "Energy-Efficient & Long-Lasting Metal Roofs",
    button: "Learn More About Metal Roofing",
    backgroundImage: "/hero/best-metal-roof-services-in-los-angeles.webp",
  },
  tpoRoof: {
    title: ['TPO Roofing', 'for Modern Protection'],
    subtitle: "Cost-Effective & Eco-Friendly Roofing Solutions",
    button: "Explore TPO Roofing",
    backgroundImage: "/hero/best-tpo-roof-services-in-los-angeles.webp",
  },
  gutter: {
    title: ['Gutter Installation', '& Maintenance'],
    subtitle: "Protect Your Home with High-Quality Gutter Solutions",
    button: "Get a Free Gutter Estimate",
    backgroundImage: "/hero/best-rain-gutter-services-in-los-angeles.webp",
  },
  blog: { // blog posts start here 
    title: ['Remodeling', 'Tips & Ideas'],
    subtitle: "Inspiration and expert advice to elevate your home.",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  top10BathroomTrends: { // post
    title: ['Top 10', 'Bathroom Trends'],
    subtitle: "Modern designs that bring luxury and function to your space.",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  outdoorLivingHardscaping: { // post
    title: ['Outdoor Living', 'and Hardscaping'],
    subtitle: "Create the ultimate backyard retreat with these expert tips.",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  aduGarageMotherInLawSuite: { // post
    title: ['ADU & Mother-in-Law', ' Suites'],
    subtitle: "Maximize your property with a stylish, private living space.",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  livingRoomRenovationIdeas: { // post
    title: ['Living Room', 'Renovation Ideas'],
    subtitle: "Smart updates to turn your living room into a showstopper.",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  bedroomRenovationGuide: { // post
    title: ['Bedroom', 'Renovation Guide'],
    subtitle: "Transform your bedroom into a peaceful and stylish escape.",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  top10KitchenTrends: { // post
    title: ['Top 10', 'Kitchen Trends'],
    subtitle: "Explore the latest innovations shaping luxury kitchens in 2025.",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  voyageLAFeature: { // post
    title: ['Inspiring Conversations', 'with Modern Build'],
    subtitle: "Featured in VoyageLA — exploring innovation, leadership, and craftsmanship behind Modern Build Home Remodeling.",
    button: "Join The Modern Build Family",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  aduGarageAndMotherInLawSuite: { // post
    title: ['Studio City ADU &', ' Mother-in-Law Suites'],
    subtitle: "Transform unused space into a beautiful, fully equipped living unit for family, guests, or rental income.",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  projects: { // projects start here 
    title: ['Our Work', 'Speaks for Itself'],
    subtitle: "Explore our portfolio of beautifully completed projects",
    button: "Start Your Project",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
  bathroomRemodelingInLosAngelesCA90069: { // project
    title: ['Bathroom Remodeling', 'in Los Angeles, CA 90069'],
    subtitle: 'Luxury finishes and spa-inspired upgrades designed for comfort and style.',
    button: 'Remodel your Bathroom Today',
    backgroundImage: '/projects/bathroom-remodeling-in-los-angeles-ca-90069/bathroom-remodeling-in-los-angeles-ca-90069.webp',
  },
  modernSpanishKitchenRemodelingInCoronaCA92883: { // project
    title: ['Spanish Style Kitchen Remodel', 'in Corona, CA 92883'],
    subtitle:
      'A modern kitchen upgrade with classic Spanish details and custom finishes.',
    button: 'Plan My Kitchen Remodel',
    backgroundImage:
      '/projects/modern-spanish-style-kitchen-remodeling-in-corona-92883/modern-spanish-style-kitchen-remodeling-in-corona-92883.webp',
  },
  modernOutdoorLivingPergolaSantaMonica90402: { // project
    title: ['Outdoor Living With Pergola', 'in Santa Monica, CA 90402'],
    subtitle:
      'A modern backyard upgrade with custom pergola and clean design.',
    button: 'Start My Outdoor Project',
    backgroundImage:
      '/projects/modern-outdoor-living-with-pergola-remodel-in-santa-monica-90402/modern-outdoor-living-with-pergola-remodel-in-santa-monica-90402.webp',
  },
  modernMasterBedroomBelAir90077: { // project
    title: ['Modern Master Bedroom Remodel', 'in Bel Air, CA 90077'],
    subtitle:
      'A calm luxury bedroom with custom lighting and refined finishes.',
    button: 'Start My Bedroom Remodel',
    backgroundImage:
      '/projects/modern-master-bedroom-remodeling-in-bel-air-los-angeles-90077/modern-master-bedroom-remodeling-in-bel-air-los-angeles-90077.webp',
  },
  highEndBathroomPacificPalisades90272: { // project
    title: ['High-End Bathroom Remodel', 'in Pacific Palisades, CA 90272'],
    subtitle:
      'A spa style bathroom with premium finishes and modern comfort.',
    button: 'Start My Bathroom Remodel',
    backgroundImage:
      '/projects/high-end-bathroom-remodeling-in-pacific-palisades-90272/high-end-bathroom-remodeling-in-pacific-palisades-90272.webp',
  },
  highEndOutdoorLivingHolmbyHills90024: { // project
    title: ['Luxury Outdoor Living Renovation', 'in Holmby Hills, CA 90024'],
    subtitle:
      'A high-end backyard upgrade with custom features and elegant design.',
    button: 'Start My Outdoor Project',
    backgroundImage:
      '/projects/high-end-outdoor-living-renovation-in-holmby-hills-los-angeles-90024/high-end-outdoor-living-renovation-in-holmby-hills-los-angeles-90024.webp',
  },
  luxuryPoolSpaPorterRanchCA91326: { // project
    title: ['Luxury Pool & Outdoor Living', 'in Porter Ranch, CA 91326'],
    subtitle:
      'A resort-style backyard renovation with custom pool, spa, artificial turf and elegant hardscape.',
    button: 'Start My Outdoor Project',
    backgroundImage:
      '/projects/luxury-pool-spa-artificial-turf-hardscaping-in-porter-ranch-ca-91326/luxury-pool-spa-artificial-turf-hardscaping-in-porter-ranch-ca-91326.webp',
  },
  luxuryKitchenEncino91316: { // project
    title: ['Luxury Kitchen Renovation', 'in Encino, Los Angeles CA 91316'],
    subtitle:
      'A high-end kitchen transformation with custom cabinetry, modern appliances, and refined finishes.',
    button: 'Start My Kitchen Remodel',
    backgroundImage:
      '/projects/luxury-kitchen-renovation-in-encino-los-angeles-91316/luxury-kitchen-renovation-in-encino-los-angeles-91316.webp',
  },
  modernFrontYardTolucaLake91602: { // project
    title: ['Modern Front Yard Renovation', 'in Toluca Lake, CA 91602'],
    subtitle:
      'A clean and modern exterior upgrade featuring custom pavers and low maintenance artificial turf.',
    button: 'Start My Front Yard Project',
    backgroundImage:
      '/projects/modern-front-yard-pavers-and-artificial-turf-in-toluca-lake-ca-91602/modern-front-yard-pavers-and-artificial-turf-in-toluca-lake-ca-91602.webp',
  },
  podcast: { // main podcast page hero
    title: ['Modern Build', 'Behind the Build'],
    subtitle: "Real stories, real contractors, real projects — insight into the world of home remodeling.",
    button: "Listen to Episodes",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  episodeHeroDefault: { // default hero for individual podcast episodes
    title: ['Modern Build', 'Behind the Build'],
    subtitle: "Listen now to industry experts and inspiring stories from homeowners.",
    button: "Listen Now",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  luxuryKitchenRemodelingCostsStudioCity91604: {
    title: ['Luxury Kitchen Remodel Costs','Studio City'],
    subtitle: "A Comprehensive Guide for High-End Homeowners",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  luxuryModernKitchenRemodelingShermanOaks91403: {
    title: ['Luxury Modern','Kitchen Remodeling'],
    subtitle: "Elevate Your Home with Exquisite Design",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  luxuryBathroomRemodelingCostInShermanOaks91423: {
    title: ['Bathroom Remodeling Cost','Sherman Oaks CA'],
    subtitle: "Average pricing, luxury upgrades, and contractor insights in 91423",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  costGuideForAduGarageConversionEncino91316: {
    title: ['ADU Garage Conversion Cost','Encino CA'],
    subtitle: "Detailed cost guide, permits, and build pricing in 91316",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  modernHomeTransformationsSLuxuryCompleteRemodelingValleyVillage91601: {
    title: ['Home Remodeling Contractor','Valley Village CA'],
    subtitle: "Full home renovation costs, design ideas, and local experts in 91601",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  luxuryModernBathroomRenovationValleyVillage91607: {
    title: ["Luxury Modern Bathroom Renovation","Valley Village"],
    subtitle: "High-End Bathroom Remodeling Ideas",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  elevateYourHomePremierHvacUpgradeValleyGlen91401: {
    title: ["Elevate Your Valley Glen Home","Premier HVAC Upgrade"],
    subtitle: "Understanding the Costs and Benefits of an HVAC System Overhaul",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  luxuryBathroomVanityInstallationCostsInStudioCity91604: {
    title: ["Luxury Bathroom Vanity","Installation Costs in Studio City"],
    subtitle: "Explore Pricing and Options for High-End Homes",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  luxuryHomeRemodelingExpertiseGuideReseda91335: {
    title: ["Luxury Home Remodeling","Reseda Expertise Guide"],
    subtitle: "Expert Insight on High-End Renovations",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },

  luxuryCountertopsStunningInstallationsInTarzana91356: {
    title: ["Luxury Countertops","Stunning Installations in Tarzana"],
    subtitle: "",
    button: "Get a Free Consultation - (323) 300-4130",
    backgroundImage: "/hero/best-home-remodling-contractor-in-los-angeles.webp",
  },
};
